var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.878 0.425915C10.4459 -0.141972 11.3666 -0.141972 11.9345 0.425918L14.3287 2.82012C14.6127 3.10407 14.6127 3.56443 14.3287 3.84838C14.0448 4.13232 13.5844 4.13232 13.3005 3.84838L11.6333 2.18125V12.4228C11.6333 12.8243 11.3078 13.1499 10.9062 13.1499C10.5047 13.1499 10.1792 12.8243 10.1792 12.4228V2.18125L8.51204 3.84838C8.2281 4.13232 7.76773 4.13232 7.48379 3.84838C7.19985 3.56443 7.19985 3.10407 7.48379 2.82012L9.878 0.425915Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63542 0.0623743C4.03697 0.0623743 4.3625 0.387901 4.3625 0.789458V11.031L6.02962 9.36387C6.31357 9.07993 6.77393 9.07993 7.05788 9.36387C7.34182 9.64782 7.34182 10.1082 7.05788 10.3921L4.66367 12.7863C4.09578 13.3542 3.17505 13.3542 2.60717 12.7863L0.212958 10.3921C-0.0709859 10.1082 -0.0709859 9.64782 0.212958 9.36387C0.496902 9.07993 0.957265 9.07993 1.24121 9.36387L2.90833 11.031V0.789458C2.90833 0.387901 3.23386 0.0623743 3.63542 0.0623743Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownArrow);
export default __webpack_public_path__ + "static/media/up-down-arrow.39bc23ba7111efe3e6252fbf806f410b.svg";
export { ForwardRef as ReactComponent };